import {KTIcon} from '../../../../_metronic/helpers'
import {useCart} from '../../../../pages/sales/create/core/cartProvider'
import {formatMask, formatMonetaryToBr} from '../../../../utils/formatMonetaryToBr'
import {useEffect, useState} from 'react'
import {ISelectPaymentOption} from '../../../../coreGlobal/models/default'
import {getPaymentOption} from '../../../../pages/sales/create/core/_request'
import {PageOverlayer} from '../../../PageOverlayer'
import {useAuth} from '../../../../app/modules/auth'
import {SwitchAction} from './SwitchAction'
import Swal from 'sweetalert2'
import {getSearchVoucher} from '../../../Voucher/_requests'

const AUTOMATIC_PAYMENTS = [1, 2, 3, 4, 5]
const VOUCHER_PAYMENT = 5
const RECURRENCY_PAYMENT = 3

const methodSize = (length, index) => {
  if (index == 0 && length === 1) {
    return 'col-10 p-0'
  }

  if (index == 0 && length != 0) {
    return 'col-12 p-0'
  }

  if (index != 0 && index < length - 1) {
    return 'col-10 p-0'
  }

  return 'col-7 p-0'
}

export const PaymentContainer = () => {
  const {currentFranchise} = useAuth()
  const [paymentOption, setStates] = useState<ISelectPaymentOption[] | undefined>([])
  const [loadingPage, setLoadingPage] = useState(false)
  const [optionInstallment, setOptionInstallment] = useState<number[]>([])

  useEffect(() => {
    async function init() {
      setLoadingPage(true)
      try {
        const data = await getPaymentOption()

        const hasEveryProductCategory = shoppingCart.every((valCart) => valCart.category === 3)

        const dataFilterRecurrence = data?.filter((val) => {
          // Se for pagamento recorrente
          if (val.value == '3') {
            // E todos os itens são produtos E a franquia NÃO permite recorrência em produtos
            if (hasEveryProductCategory && !currentFranchise?.config.acceptsRecurringProducts) {
              return false // não exibe essa opção
            }
          }
          return true // exibe outras opções
        })

        setStates(dataFilterRecurrence)

        if (dataFilterRecurrence && dataFilterRecurrence.length > 0) {
          handlePaymentDefault(dataFilterRecurrence[0])
        }
      } catch (error) {
      } finally {
        setLoadingPage(false)
      }
    }

    init()
  }, [])
  const {
    payment,
    setPayment,
    addMethodPayment,
    removeMethodPayment,
    handleChangeTypeMethodPayment,
    handleChangeValueMethodPayment,
    handleChangeInstallments,
    sum,
    shoppingCart,
  } = useCart()

  useEffect(() => {
    if (!paymentOption?.length) return

    const available = paymentOption.map((option) => Number(option.value))
    if (payment.every((pay) => available.includes(Number(pay.method)))) return

    const firstOption =
      paymentOption.find((option) => AUTOMATIC_PAYMENTS.includes(Number(option.value))) ??
      paymentOption[0]
    const method = Number(firstOption.value)
    const recurrency = method === RECURRENCY_PAYMENT
    const installmentEnabled = Boolean(firstOption.installment_enabled)

    if (installmentEnabled) {
      const minInstallment = recurrency ? 2 : 1
      setOptionInstallment(
        Array.from(
          {length: Number(firstOption.numberInstallment) - minInstallment + 1},
          (_, i) => i + minInstallment
        )
      )
    }

    setPayment((prev) =>
      prev.map((pay) =>
        available.includes(Number(pay.method))
          ? pay
          : {
              ...pay,
              method,
              recurrency,
              hasInstallment: installmentEnabled,
              numberOfInstallments: recurrency ? 2 : 1,
            }
      )
    )
  }, [paymentOption, payment])

  function handlePaymentDefault(dta: any) {
    let newData = [...payment]
    newData[0] = {
      ...payment[0],
      method: dta.value,
      value: 0,
      numberOfInstallments: dta.value == 3 ? 2 : 1,
      hasInstallment: dta.installment_enabled,
      recurrency: Number(dta.value) === RECURRENCY_PAYMENT,
    }
    setPayment(newData)
    const minInstallment = Number(dta.value) === RECURRENCY_PAYMENT ? 2 : 1
    setOptionInstallment(
      Array.from(
        {length: Number(dta.numberInstallment) - minInstallment + 1},
        (_, i) => i + minInstallment
      )
    )
  }

  const hasInstallment = (id, index, e) => {
    const data = paymentOption?.find((val) => {
      return val.value == id && val.installment_enabled == true
    })

    if (data !== undefined) {
      handleChangeTypeMethodPayment(index, e, true)
      const minInstallment = Number(data.value) === RECURRENCY_PAYMENT ? 2 : 1
      const installmentsArray = Array.from(
        {length: Number(data?.numberInstallment) - minInstallment + 1},
        (_, i) => i + minInstallment
      )
      setOptionInstallment(installmentsArray)
      return
    }

    handleChangeTypeMethodPayment(index, e, false)
  }

  const filterVoucher = async (index: number, payVoucher: string) => {
    setLoadingPage(true)
    try {
      const data = await getSearchVoucher(payVoucher)
      if (data) {
        if (data.amount > sum) {
          await Swal.fire({
            title: `O valor do voucher é ${formatMonetaryToBr(
              data.amount
            )}. Está excedendo o valor da compra. Deseja utiliza-lo?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar',
            customClass: {
              confirmButton: 'btn btn-danger',
              cancelButton: 'btn btn-secondary',
            },
          }).then(async (result) => {
            if (result.isConfirmed) {
              handleChangeValueMethodPayment(index, formatMonetaryToBr(sum), data.code)
            } else {
              handleChangeValueMethodPayment(index, formatMonetaryToBr(0), '')
            }
          })
        } else {
          handleChangeValueMethodPayment(index, formatMonetaryToBr(data.amount), data.code)
        }
      } else {
        handleChangeValueMethodPayment(index, formatMonetaryToBr(0), '')
      }
    } catch (error: any) {
      await Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response.data.message,
        showConfirmButton: false,
        allowOutsideClick: false,
        timer: 2000,
      })
      return
    } finally {
      setLoadingPage(false)
    }
  }

  return (
    <>
      {loadingPage ? (
        <PageOverlayer />
      ) : (
        payment?.map((pay, index) => {
          const paymentMethodSize = methodSize(payment.length, index)
          return (
            <div key={`paymentMap-${pay.paymentRef}-${index}`} className='mb-8 w-100'>
              <label>{index + 1}. Forma:</label>
              <div className='row m-0 col-12'>
                <div className={paymentMethodSize}>
                  <select
                    className='form-select form-select-lg form-control form-control-lg form-control-solid mb-3 mb-lg-0 border border-dark'
                    value={pay.method}
                    onChange={(e) => {
                      hasInstallment(e.target.value, index, e)
                    }}
                  >
                    {paymentOption?.some((option) =>
                      AUTOMATIC_PAYMENTS.includes(Number(option.value))
                    ) && (
                      <optgroup label='Automáticos:'>
                        {paymentOption
                          .filter((option) => AUTOMATIC_PAYMENTS.includes(Number(option.value)))
                          .map((option) => (
                            <option
                              key={`automatic-${pay.paymentRef}-${option.value}-${index}`}
                              value={option.value}
                            >
                              {option.label}
                            </option>
                          ))}
                      </optgroup>
                    )}

                    {paymentOption?.some(
                      (option) => !AUTOMATIC_PAYMENTS.includes(Number(option.value))
                    ) && (
                      <optgroup label='Manuais:'>
                        {paymentOption
                          .filter((option) => !AUTOMATIC_PAYMENTS.includes(Number(option.value)))
                          .map((option) => (
                            <option
                              key={`manuals-${pay.paymentRef}-${option.value}-${index}`}
                              value={option.value}
                            >
                              {option.label}
                            </option>
                          ))}
                      </optgroup>
                    )}
                  </select>
                </div>
                <SwitchAction
                  position={index + 1}
                  length={payment.length}
                  addMethodPayment={addMethodPayment}
                  removeMethodPayment={() => {
                    removeMethodPayment(pay.paymentRef)
                  }}
                />
              </div>
              <div className='row mt-2 m-0'>
                {pay.method != VOUCHER_PAYMENT && (
                  <div className={'col-8 p-0'}>
                    <label>Valor:</label>
                    <input
                      className='form-control form-control-lg form-control-solid mb-3 mb-lg-0 border border-dark col-5'
                      value={formatMask(sum === 0 ? 0 : pay.value)}
                      onChange={(e) => {
                        handleChangeValueMethodPayment(index, formatMask(e.target.value), '')
                      }}
                    />
                  </div>
                )}

                {pay.hasInstallment && pay.method != VOUCHER_PAYMENT && (
                  <div className='col-4 p-0 ps-2'>
                    <label>N. Parcelas:</label>
                    <select
                      className='form-select form-select-lg form-control form-control-lg form-control-solid mb-3 mb-lg-0 border border-dark'
                      value={pay.numberOfInstallments}
                      onChange={(e) => handleChangeInstallments(index, e.target.value)}
                    >
                      {optionInstallment.map((val) => (
                        <option key={`numberPlots-${pay.paymentRef}-${val}-${index}`} value={val}>
                          {val}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {pay.method == VOUCHER_PAYMENT && (
                  <>
                    <div className={'col-8 p-0'}>
                      <label>Voucher:</label>
                      <input
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0 border border-dark col-5'
                        value={pay.voucher}
                        onChange={(e) => {
                          handleChangeValueMethodPayment(
                            index,
                            formatMonetaryToBr(0),
                            String(e.target.value)
                          )
                        }}
                      />
                    </div>
                    <div className='col-2 p-0 ms-2 me-2 mt-6'>
                      <button
                        onClick={async () => {
                          filterVoucher(index, pay.voucher)
                        }}
                        className={`btn btn-light-danger font-weight-bold w-auto ${
                          !pay.voucher ? 'disabled' : ''
                        }`}
                      >
                        <KTIcon iconName='filter' className='svg-icon svg-icon-danger' />
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          )
        })
      )}
    </>
  )
}
